import axios from '../../config/axios.js'
import store from '../../vuex/store.js'
import jwt_decode from 'jwt-decode'
import * as firebase from "firebase/app"

const STATE = {

    access_token: null,
    refresh_token: null,

    token_fresh: false,
    token_memberships: false,
    token_status: false,
    token_role: null,
    language: null,

    available_username: true,
    available_email: true,
    token_valid: false,

    is_expired: false,

}

const GETTERS = {

    access_token: state => state.access_token,
    is_authenticated: state => !!state.access_token,
    refresh_token: state => state.refresh_token,

    token_fresh: state => state.token_fresh,
    token_memberships: state => state.token_memberships,
    token_status: state => state.token_status,
    token_role: state => state.token_role,
    language: state => state.language,

    available_username: state => state.available_username,
    available_email: state => state.available_email,
    token_valid: state => state.token_valid,

    is_expired: state => state.is_expired,

}

const MUTATIONS = {

    setAccessToken(state, access_token) {
        state.access_token = access_token
        if (!!access_token) {
            state.token_fresh = jwt_decode(access_token).fresh
            state.token_memberships = jwt_decode(access_token).user_claims.memberships
            state.token_status = !!jwt_decode(access_token).user_claims.status
            state.token_role = jwt_decode(access_token).user_claims.role
            state.language = jwt_decode(access_token).user_claims.language
        }
    },

    storeAccessToken(state, access_token) {
        localStorage.setItem('access_token', access_token)
    },

    setRefreshToken(state, refresh_token) {
        state.refresh_token = refresh_token
    },

    storeRefreshToken(state, payload) {
        localStorage.setItem('refresh_token', payload.refresh_token)
    },

    clearTokens(state) {
        // console.log('auth/clearTokens')
        localStorage.clear()
        state.access_token = null
        state.refresh_token = null
    },

    clearAccessToken(state) {
        // console.log('auth/clearAccessToken')
        localStorage.removeItem('access_token')
        state.access_token = null
    },

    clearRefreshToken(state) {
        // console.log('auth/clearRefreshToken')
        localStorage.removeItem('refresh_token')
        state.refresh_token = null
    },

    checkUsername(state, available) {
        state.available_username = available
    },

    checkEmail(state, result) {
        state.available_email = !result
    },

    setAdminRegisterResult(state, result) {
        state.admin_register_result = result
    },

    checkToken(state, result) {
        state.token_valid = result
    },

    setExpired(state, is_expired) {
        state.is_expired = is_expired
    },

}

const ACTIONS = {

    async register({ commit }, payload) {
        await axios.GENERAL.post('/api/register', {
                username: payload.username,
                firstname: payload.firstname,
                lastname: payload.lastname,
                email: payload.email,
                password: payload.password,
                language: payload.language,
            })
            .then(res => {
                // console.log('auth/register', res)
                if (res.data.result) {
                    commit('setAccessToken', res.data.access_token)
                    commit('storeAccessToken', res.data.access_token)
                    commit('storeRefreshToken', {
                        refresh_token: res.data.refresh_token
                    })
                } else {
                    throw new Error(res.data)
                }
            })
    },

    async login({ commit }, payload) {
        await axios.GENERAL.post('/api/login', {
                username: payload.username,
                password: payload.password,
            })
            .then(res => {
                // console.log('auth/login', res)
                if (res.data.result) {
                    // TODO: rememberme
                    commit('setAccessToken', res.data.access_token)
                    commit('storeAccessToken', res.data.access_token)
                    commit('storeRefreshToken', {
                        refresh_token: res.data.refresh_token,
                    })
                } else {
                    throw new Error(res.data)
                }
            })
    },

    async reload({ commit }) {
        // console.log('/api/auth/reload')
        let access_token = localStorage.getItem('access_token')
        try {
            jwt_decode(access_token)
        } catch (e) {
            commit('clearTokens')
            access_token = null
        } finally {
            if (!!access_token) {
                commit('setAccessToken', access_token)
            }
        }
    },

    async logout({ commit, dispatch }) {
        // console.log('logout')
        firebase.analytics().logEvent('logout')
        await dispatch('revokeTokens')
        commit('clearTokens')
        location.reload()
    },

    async logoutManually({ commit, dispatch }) {
        // console.log('logoutManually')
        firebase.analytics().logEvent('logout')
        await dispatch('revokeTokens')
        commit('clearTokens')
    },

    async updateToken({ state, commit, dispatch }) {
        state.refresh_token = localStorage.getItem('refresh_token')
            // console.log(state.refresh_token)
        await axios.CONFIRM.post('/api/token/refresh')
            .then(res => {
                // console.log('auth/updateToken', res, res.data.result)
                // console.log(res.data.result, res.data)
                if (res.data.result) {
                    commit('storeAccessToken', res.data.access_token)
                    commit('setAccessToken', res.data.access_token)
                } else {
                    throw new Error(res.data)
                }
            })
            .catch(async(e) => {
                await dispatch('logout')
                throw new Error()
            })
    },

    async revokeTokens({ state, commit }) {
        state.access_token = localStorage.getItem('access_token')
        state.refresh_token = localStorage.getItem('refresh_token')
            // console.log('auth/revokeToken')
        if (!!state.access_token) {
            await axios.REVOKE.post('/api/logout/access')
                .then(res => {
                    // console.log('auth/logout/access', res)
                })
                .catch(e => {
                    commit('clearAccessToken')
                })
        }
        if (!!state.refresh_token) {
            await axios.REVOKE.post('/api/logout/refresh')
                .then(res => {
                    // console.log('auth/logout/refresh', res)
                })
                .catch(e => {
                    commit('clearRefreshToken')
                })
        }
    },

    async checkUsername({ commit }, payload) {
        await axios.GENERAL.get('/api/checkusername/' + payload.username)
            .then(res => {
                // console.log('auth/checkUsername', res)
                commit('checkUsername', res.data.available)
            })
    },

    async checkEmail({ commit }, payload) {
        await axios.GENERAL.post('/api/user/checkemail', {
                email: payload.email
            })
            .then(res => {
                // console.log('auth/checkEmail', res)
                commit('checkEmail', res.data.result)
            })
    },

    async checkToken({ commit }, payload) {
        await axios.GENERAL.get('/api/user/password/' + payload.token)
            .then(res => {
                // console.log('auth/checkToken', res)
                commit('checkToken', res.data.result)
            })
            .catch(e => {
                commit('checkToken', false)
            })
    },

    async resetPassword({ commit }, payload) {
        await axios.GENERAL.post('/api/user/password/' + payload.token, {
                password: payload.password
            })
            .then(res => {
                // console.log('auth/resetPassword', res)
                if (res.data.result) {
                    commit('setAccessToken', res.data.access_token)
                    commit('storeAccessToken', res.data.access_token)
                    commit('storeRefreshToken', {
                        refresh_token: res.data.refresh_token,
                    })
                } else {
                    throw new Error(res.data)
                }
            })
    },

}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
    actions: ACTIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/auth.js